module.exports = __webpack_public_path__ + "static/media/unamlogo.cf23a98b.png";